export default "__VITE_ASSET__BYRMXgo1__"